var _ellipse, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 25,
    viewBox: "0 0 28 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.9419,
    cy: 7,
    rx: 9.36763,
    ry: 7,
    fill: "#B1CA16"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.3233 25H13.9409H0.558594C0.558594 19.4772 6.55007 15 13.9409 15C21.3318 15 27.3233 19.4772 27.3233 25Z",
    fill: "#B1CA16"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.47f25fd80f368c04e50c8de4e3d4107f.svg";
export { ForwardRef as ReactComponent };